//export const api_domain = "https://api.kadara.cs.washington.edu"
export const api_domain = "https://api-ad-archive.cs.washington.edu"
// export const api_domain = "http://127.0.0.1:8001"
